import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './AECard.module.css';

/**
 * A reusable card component with a default border, background, and shadow.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.className] - Additional class names for customizing the card.
 * @param {JSX.Element|JSX.Element[]} props.children - The content to render inside the card.
 */
const AECard = ({
  className = '',
  children,
  disabled = false,
  outdated = false,
  title,
}) => {
  return (
    <div
      title={title || undefined}
      className={clsx(
        styles.aeCard,
        {
          [styles['aeCard--disabled']]: disabled,
          [styles['aeCard--outdated']]: outdated,
        },
        className
      )}
    >
      {children} {/* Render any children passed inside the card */}
    </div>
  );
};

// Prop types validation
AECard.propTypes = {
  className: PropTypes.string, // Optional additional class names for styling
  children: PropTypes.node.isRequired, // Children (content) are required to render inside the card
  disabled: PropTypes.bool, // Optional additional class names for styling
  outdated: PropTypes.bool, // Optional additional class names for styling
  title: PropTypes.string, // Optional native hover hint (caller-supplied copy)
};

export default AECard;
